import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Title from '../title/Title';
import EirButton from '../eir-button/EirButton';
import Subtitle from '../subtitle/Subtitle';
import AspectRatioContainer from '../aspect-ratio-container/AspectRatioContainer'

class ThreeColumn extends Component {

  constructor(props) {
    super(props);
  }
  
  render() {
    return (
      <Container fluid={this.props.fluid} className={'eir-three-column mb-6 mt-6' + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default') }>
        <Row >  
          {this.props.tiles.map(tile => {
            return (
               <Col xs="12" md="4" className="text-center mb-4 pl-4 pr-4">
                {tile.image &&
                  <AspectRatioContainer xs="15-8" className={'eir-theme-' + (tile.theme ? tile.theme : 'default')} >
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <img className="img-fluid mh-100 mh-100" src={tile.image.path} alt={tile.image.description} />
                    </div>
                  </AspectRatioContainer>
                }

                <Title title={tile.title} />

                <Subtitle text={tile.text} />

                {tile.cta &&
                  <EirButton {...tile.cta} />
                }
              </Col>
            );
          })
          }
        </Row>
      </Container>
    );
  }
}

export default ThreeColumn;